import axios from '@/lib/axios';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

/** Matches customer app `GET /booking/:bookingId/review-status/`. */
export interface BookingReviewStatusCleaner {
  cleaner_id: string;
  cleaner_name: string;
  review_submitted: boolean;
  tip_submitted: boolean;
}

export interface BookingReviewStatus {
  booking_id: string;
  cleaners: BookingReviewStatusCleaner[];
}

export const bookingReviewStatusQueryKey = (bookingId: string) =>
  ['booking', 'review-status', bookingId] as const;

async function getBookingReviewStatus(
  bookingId: string
): Promise<BookingReviewStatus> {
  const { data } = await axios.get(`/booking/${bookingId}/review-status/`);
  return data as BookingReviewStatus;
}

export function useGetBookingReviewStatusQuery(
  bookingId: string,
  options?: Omit<
    Partial<UseQueryOptions<BookingReviewStatus, Error>>,
    'queryKey' | 'queryFn'
  >
) {
  const { enabled: enabledFromOptions, ...rest } = options ?? {};
  return useQuery({
    queryKey: bookingReviewStatusQueryKey(bookingId),
    queryFn: () => getBookingReviewStatus(bookingId),
    retry: false,
    enabled:
      !!bookingId &&
      bookingId.trim().length > 0 &&
      (enabledFromOptions ?? true),
    ...rest,
  });
}
